<template>
  <!-- 下载记录 -->
  <div class="download">
    <Category @handle-category="handleCategoryChange" />
    <PublicList text="下载" :category="category" :list="downloadList" :onMoreLoad="onMoreReadList" :isShow="isShow" />
    <!-- <template v-if="!isShow">
      <div class="row" v-for="(item, i) in downloadList" :key="i">
        <el-alert :title="'下载时间 '+ item.day" type="info" show-icon :closable="false">
        </el-alert>
        <article-list :honDocuList="honDocuListMap[i]" :isIndex="false" :isIcon="true" />
      </div>
    </template>
    <placeholder :isShow="isShow" /> -->
  </div>
</template>
<script>
import { Loading } from 'element-ui'
import { getDownloadRecords } from '@/api/user.js'
import Category from './category.vue'
import PublicList from './publicList.vue'
import guideline from '@/api/guideline.js'
export default {
  components: {
    Category,
    PublicList
  },
  data () {
    return {
      downloadList: [],
      isShow: true,
      honDocuListMap: {},
      page: {
        pageNum: 1,
        pageSize: 10
      },
      category: 0,
      loading: false
    }
  },
  methods: {
    showLoading () {
      this.loading = Loading.service({
        lock: true,
        text: '正在加载，请耐心等待...'
      })
    },
    // 加载更多
    onMoreReadList () {
      this.showLoading()
      this.page.pageNum++
      this.getDownloadRecords()
    },
    handleCategoryChange (category) {
      this.category = category
      this.page = {
        pageNum: 1,
        pageSize: 10
      }
      this.downloadList = []
      this.getDownloadRecords()
    },
    // 还原驼峰
    setkey (arr) {
      return arr.map(item => {
        const obj = {}
        Object.keys(item).forEach(key => {
          const camelKey = key
            .split('_')
            .map((k, i) => i === 0 ? k : k.charAt(0).toUpperCase() + k.slice(1))
            .join('')
          // if (camelKey === 'docTitleZh') {
          //   this.$set(obj, camelKey, '')
          //   return
          // }
          this.$set(obj, camelKey, item[key])
        })
        return obj
      })
    },
    // 获取用户下载文献列表
    async getDownloadRecords () {
      try {
        const res = await (this.category ? guideline.guidDownloadList({ ...this.page, type: 1 }) : getDownloadRecords())
        const fetchedCount = res.data.reduce((sum, day) => sum + (day.subList ? day.subList.length : 0), 0)
        res.data.forEach((item, index) => {
          this.$set(
            this.honDocuListMap,
            index,
            this.setkey(item.subList)
          )
        })
        if (this.category === 0) {
          this.isShow = true
          this.downloadList = res.data
        } else {
          this.isShow = fetchedCount < this.page.pageSize
          this.downloadList = [...this.downloadList, ...res.data]
        }
      } catch (error) {
        this.$message.error(error)
      } finally {
        if (this.loading) this.loading.close()
      }
    }
  },
  created () {
    this.getDownloadRecords()
  }
}
</script>
<style lang="less" scoped>
.download {
  min-height: 630px;
  padding-top: 1px;
  .row:first-of-type{
    padding-top: 8px;
  }
}
.el-alert {
  position: relative;
  background-color: #f5f7fb;
  padding: 0 10px;
  /deep/.el-alert__title {
    font-size: 14px;
  }
}
</style>
